import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { useQuery } from '@apollo/client';

import BlogManagement from '../../../components/siteadmin/Blog/BlogManagement';

import getBlogDetails from './getBlogDetails.graphql';

import s from './BlogManagement.css';
function BlogManagements() {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, loading, refetch } = useQuery(getBlogDetails, {
    variables: { currentPage: 1, searchList: '' },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  const setStateVariable = (variables) => {
    if (variables.currentPage !== undefined) {
      setCurrentPage(variables.currentPage);
    }
  };

  return (
    <BlogManagement
      data={data}
      loading={loading}
      refetch={refetch}
      setStateVariable={setStateVariable}
    />
  );
}

BlogManagements.propTypes = {
  title: PropTypes.string,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getBlogDetails: PropTypes.array,
  }),
};

BlogManagements.defaultProps = {
  data: {
    loading: true,
  },
};

export default compose(
  withStyles(s)
)(BlogManagements);
